import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_dc295ef5-578e-436e-93fb-367679b984e5/artifacts/owgk1nux_tandaa_logo.png";

export default function TopBar({ active, sticky }) {
  return (
    <header className={`tn-top ${sticky ? "is-sticky" : ""}`} data-testid="top-bar">
      <Link to="/" className="tn-brand" data-testid="brand-link" aria-label="Tandaa Networks home">
        <span className="tn-logo-tile" aria-hidden="true">
          <img src={LOGO_URL} alt="" />
        </span>
        <span className="tn-brand-text">
          <span className="tn-brand-name">TANDAA</span>
          <span className="tn-brand-sub">REDEFINING CONNECTIVITY</span>
        </span>
      </Link>
      <div className="tn-top-right">
        <nav className="tn-nav" data-testid="top-nav">
          <Link to="/" className={active === "home" ? "active" : ""} data-testid="nav-home">Home</Link>
          <Link to="/coverage.html" className={active === "coverage" ? "active" : ""} data-testid="nav-coverage">Coverage</Link>
          <Link to="/order.html" className={active === "order" ? "active" : ""} data-testid="nav-order">Order</Link>
        </nav>
        <a
          href="tel:+254730729729"
          className="tn-btn tn-top-call-btn"
          data-testid="top-call-us-btn"
          aria-label="Call Tandaa Networks at +254 730 729 729"
        >
          Call us →
        </a>
      </div>
    </header>
  );
}
